import React from 'react';
import { View } from 'react-native';
import {Checkbox} from 'react-native-paper';

export const CustomCheckbox = ({style , onPress }) => {
  const [checked, setChecked] = React.useState(false);
  return (
    <View style={style}>
      <Checkbox
        status={checked ? 'checked' : 'unchecked'}
        color="#F34F42"
        uncheckedColor={'#DCDCDC'}
        onPress={(e) => {
          setChecked(!checked);
          onPress && onPress(!checked)
        }}
      />
    </View>
  );
};